<template>
    <div id="tiny">
      <Editor v-if='init' v-on:onInit='initialized' v-model="value.html" @input="textChanged" :id='editorId'
              :init="{
         height: editorHeight,
         menubar: true,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         branding: false,
         toolbar:
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
       }"
      />
    </div>
</template>

<!-- eslint-disable -->
<script>
import { mapState } from 'vuex';
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css'
import 'tinymce/skins/content/default/content.min.css'
// import 'tinymce/skins/content/default/content.css';

import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/code';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';

import Editor from '@tinymce/tinymce-vue';
import { EventBus, EVENTS } from '../libs/eventBus';

export default {
  name: 'TinyMCE',
  components: {
    Editor,
  },
  props: {
    editorHeight: {
      type: Number,
      required: false,
      default: 500
    },
    editorId: {
      type: String,
      required: false,
      default: 'editor'
    },
    value: {
      type: Object,
      required: true,
      default: {},
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
  data: () => ({
    init: false,
  }),
  computed: mapState([
  ]),
  methods: {
    initialized() {
      console.log('initialized: ', this.editorId, this.value.page)
      this.$emit('loaded', this.editorId)
    },
    textChanged(evt) {
      if(this.value){
        this.value.modified = true; // to be able to sync them
      }
      this.$emit('textChanged'); // to inform parent component
      // console.log('Text changed', evt);
    },
  },
  mounted() {
    console.log('tinymce', 'init');
    this.init = true;
    EventBus.$on(EVENTS.MCE_INSERT_TEXT, (text) => {
      console.log('EVENT INSERT TEXT', text);
      console.log(tinymce.activeEditor);
      tinymce.activeEditor.execCommand('mceInsertContent', false, text);
    });
  },
  beforeDestroy() {

  },
};
</script>
<style>

</style>
